import { Link } from 'react-router-dom';
import Skeleton from '../../../../../components/Skeleton/Skeleton';
import SvgIcons from '../../../../../services/SvgIcons';
import BackgroundImageWithSkeleton from '../../../../../components/BackgroundImageWithSkeleton/BackgroundImageWithSkeleton';
import './MyPersonalInformations.scss';

export default function MyPersonalInformations({ user, loading, hasActivePlans }) {
    const actions = [
        { to: '/mon-compte/modifier',             icon: 'edit',        label: 'Mes informations' },
        { to: '/mon-compte/changer-mot-de-passe', icon: 'password',    label: 'Mot de passe' },
        { to: '/mon-compte/mes-achats',           icon: 'document',    label: 'Mes achats' },
        ...(hasActivePlans ? [{ to: '/mon-compte/moyen-de-paiement', icon: 'credit_card', label: 'Moyen de paiement' }] : []),
    ];
    return (
        <section className="account-page_my-personal-informations__profile">
            <div className="account-page_my-personal-informations__profile-header">
                <div className="account-page_my-personal-informations__avatar">
                    {
                        !loading ?
                            user?.picture ? (
                                <BackgroundImageWithSkeleton
                                    picture={user.picture}
                                    height='120px'
                                    width='120px'
                                    positionMobile='static'
                                    positionDesktop='static'
                                    borderRadius='60px'
                                />
                            ) : (
                                <SvgIcons
                                    name="user"
                                    width="100"
                                    height="100"
                                    color="#6D4F47"
                                />
                            )
                            :
                            <Skeleton
                                width="120px"
                                height="120px"
                                borderRadius="60px"
                                bkgColor="#EEE6DB"
                                animColor="#F5F0ED"
                            />
                    }
                </div>
                <div className="account-page_my-personal-informations__user-info">
                    {
                        !loading ?
                            <h2>
                                {user?.firstname + ' ' + user?.lastname}
                            </h2>
                        :
                            <Skeleton
                                width='60%'
                                height='40px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='0 0 0.5rem 0'
                            />
                    }
                    {
                        !loading ?
                            <p>
                                {user?.email}
                            </p>
                        :
                            <Skeleton
                                width='60%'
                                height='24px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='0 0 0.5rem 0'
                            />
                    }
                    {
                        !loading ?
                            <p>
                                {'Membre depuis le ' + new Date(user?.createdAt).toLocaleDateString()}
                            </p>
                        :
                            <Skeleton
                                width='60%'
                                height='24px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='0 0 0.5rem 0'
                            />
                    }
                    <div className="account-page_my-personal-informations__newsletter">
                        {
                            !loading ?
                                <>
                                    <input
                                        type="checkbox"
                                        id="newsletter"
                                        defaultChecked={user?.newsletter}
                                        disabled
                                        className="account-page_my-personal-informations__newsletter-checkbox"
                                    />
                                    <label htmlFor="newsletter">{user?.newsletter ? 'Inscrit(e) à la newsletter' : "Tu n'est pas inscrit(e) à la newsletter"}</label>
                                </>
                                :
                                <Skeleton
                                    width='60%'
                                    height='24px'
                                    borderRadius='3px'
                                    bkgColor='#EEE6DB'
                                    animColor='#F5F0ED'
                                />
                        }

                    </div>
                </div>
            </div>

            <div className="account-page_my-personal-informations__actions">
                {actions.map(({ to, icon, label }) => (
                    <Link key={to} to={to} className="account-page_my-personal-informations__action-card">
                        <span className="account-page_my-personal-informations__action-icon">
                            <SvgIcons name={icon} width="28" height="28" color="currentColor" />
                        </span>
                        <span className="account-page_my-personal-informations__action-label">{label}</span>
                    </Link>
                ))}
            </div>
        </section>
    )
}
